const sortProductAttributes = (attributesArr) => {
  attributesArr.forEach((item) => {
    if (
      item?.groupedBy?.startsWith('nominal') ||
      item?.groupedBy === 'marketingProfile'
    ) {
      const original = item.attributeName.startsWith('Double ')
        ? item.attributeName.replace('Double ', '').replace(/('|")/g, '')
        : item.attributeName.replace(/ [\s\S]+/, '').replace(/('|")/g, '');

      item.number = {
        original,
      };

      if (item.number.original.includes('-')) {
        [item.number.integer, item.number.fraction] =
          item.number.original.split('-');
      } else {
        item.number.integer = 0;
        item.number.fraction = item.number.original;
      }

      if (item.number.fraction.includes('/')) {
        [item.number.numerator, item.number.denominator] =
          item.number.fraction.split('/');
      } else {
        item.number.numerator = item.number.fraction;
        item.number.denominator = 1;
      }

      item.number.numeral =
        +item.number.integer +
        +item.number.numerator / +item.number.denominator;
    }
  });

  if (attributesArr?.length > 0) {
    attributesArr.sort((a, b) => {
      if (a?.number?.numeral && b?.number?.numeral) {
        return a.number.numeral - b.number.numeral;
      }

      if (a?.attributeName?.length > 0 && b?.attributeName?.length > 0) {
        const aLowerCase = a.attributeName.toLowerCase();
        const bLowerCase = b.attributeName.toLowerCase();

        return aLowerCase.localeCompare(bLowerCase);
      }

      return 0;
    });
  }
};

export default sortProductAttributes;
